import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Highlight from 'react-highlight.js';

export default class TypeCard extends React.Component {

  render(){

    return (
      <Paper className={this.props.style}>
        <Box>
          <Typography variant="h6" gutterBottom>
            {this.props.title}
          </Typography>
          <Highlight language={this.props.lang}>
            {this.props.html}
          </Highlight>
        </Box>
      </Paper>
    );
  }
}
